import { HTTP } from './http';

export const requestOrg = (id) => new Promise((resolve, reject) => HTTP.get(`/organisations/v2/configuration?domain=${id}`,
  {
    headers: {
      'Authorization': '',
    },
  })
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

export const requestHomepagePhrases = () => new Promise((resolve, reject) => HTTP.get('/phrases/home')
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

export const requestServiceLinks = (id, domain) => new Promise((resolve, reject) => HTTP.get(`/homepage-navs/${id}/categories?domain=${domain}`)
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));


export const requestSearchOrg = id => new Promise((resolve, reject) => HTTP.get(`/organisations?search_term=${id}`)
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));



// WEBPACK FOOTER //
// ./client/api/org.js